export const SEARCH_PROP_TYPES = {
  NUMBER: "number",
  NUMBER_GTE: "number_gte",
  NUMBER_LTE: "number_lte",
  ENUM_MULTI: "enum_multi",
  STRING: "string",
  STRING_STRICT: "string_strict",
  STRING_MULTI: "string_multi",
  OBJECT_ID: "oid",
  LOCALE: "locale"
};



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-search.ts